import type { SyncDisplayStatus } from '@oxxean/types';
import type { IconName } from '../components/Icon';

/**
 * Los seis estados de sincronización (§33).
 *
 * «Sin conexión» y «Sin datos» son estados DISTINTOS y así se presentan: el
 * incidente del 2026-07-24 se produjo porque la interfaz los mezclaba y un origen
 * caído se leyó como «no hay nada que mostrar». Cada estado tiene etiqueta, icono
 * y color propios.
 */
export interface SyncStatusMeta {
  label: string;
  icon: IconName;
  description: string;
  /** Orden de gravedad: el indicador del encabezado muestra el peor. */
  severity: number;
}

export const SYNC_STATUS_META: Record<SyncDisplayStatus, SyncStatusMeta> = {
  UP_TO_DATE: {
    label: 'Actualizado',
    icon: 'check',
    description: 'La última sincronización terminó completa y sin errores.',
    severity: 0,
  },
  SYNCING: {
    label: 'Sincronizando',
    icon: 'sync',
    description: 'Hay una ejecución en curso; las cifras pueden cambiar al terminar.',
    severity: 1,
  },
  PARTIAL: {
    label: 'Parcial',
    icon: 'alert',
    description: 'La sincronización terminó, pero no cubrió todo el período.',
    severity: 3,
  },
  ERROR: {
    label: 'Error',
    icon: 'alert',
    description: 'La última ejecución falló. Revise el detalle de errores.',
    severity: 5,
  },
  OFFLINE: {
    label: 'Sin conexión',
    icon: 'cloud-off',
    description: 'El origen no respondió. No es lo mismo que no tener datos.',
    severity: 4,
  },
  NO_DATA: {
    label: 'Sin datos',
    icon: 'database-off',
    description: 'El origen respondió, pero no hay registros para el período.',
    severity: 2,
  },
};

export function worstSyncStatus(statuses: SyncDisplayStatus[]): SyncDisplayStatus | null {
  if (statuses.length === 0) return null;
  return statuses.reduce((worst, candidate) =>
    SYNC_STATUS_META[candidate].severity > SYNC_STATUS_META[worst].severity ? candidate : worst,
  );
}
